import classNames from 'clsx';
import React, { type FC, type ReactElement, type ReactNode } from 'react';

import styles from './SubscriptionInfoBlock.css';

interface IProps {
    title?: string;
    id: string;
    size?: 'medium' | 'large';
    footer?: ReactNode;
    qaId?: string;
    isFreemium?: boolean;
}

export const SubscriptionInfoBlock: FC<IProps> = ({ title, id, children, footer, size = 'medium', qaId, isFreemium }): ReactElement => {
    return (
        <div
            className={classNames(styles.root, {
                [styles[`root_${id}`]]: id,
                [styles[`root_size_${size}`]]: size,
            })}
            data-qa-id={qaId}
        >
            {title && (
                <div
                    className={classNames(styles.title, {
                        [styles.freemiumTitle]: isFreemium,
                    })}
                >
                    {title}
                </div>
            )}
            <div className={styles.info}>{children}</div>
            {footer}
        </div>
    );
};

SubscriptionInfoBlock.displayName = 'SubscriptionInfoBlock';
